import React, { useState } from 'react';
import { IconPlus, IconSearch, IconGrid, IconEdit, IconTrash } from './Icons';
import './SalaryAdvance.css';

const SAMPLE_ADVANCE = {
  id: 1,
  employee: 'Majida Admin',
  amount: '12',
  date: '2025-02-10',
  deductionMonth: '2025-02-09',
  installments: 3,
  details: ['Feb 2025 : 4', 'Mar 2025 : 4', 'Apr 2025 : 4'],
};

export default function SalaryAdvance() {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const COLUMNS = [
    { key: 'id', label: 'ID' },
    { key: 'employee', label: 'Employee' },
    { key: 'amount', label: 'Amount' },
    { key: 'date', label: 'Date' },
    { key: 'deductionMonth', label: 'Deduction Month' },
    { key: 'installments', label: 'Installments' },
    { key: 'installmentDetails', label: 'Installment Details' },
  ];

  const activeColumnCount = COLUMNS.length + 1; // +1 for actions column

  return (
    <div className="adv-page">
      <div className="adv-card">
        <div className="adv-header-row">
          <h1 className="adv-title">Advances List</h1>
          <div className="adv-header-actions">
            <button
              type="button"
              className="adv-header-btn adv-header-btn-primary"
              onClick={() => setShowAddModal(true)}
            >
              <IconPlus />
              Add Advance
            </button>
          </div>
        </div>

        <div className="adv-filters-row">
          <div className="adv-filters-left">
            <button
              type="button"
              className="adv-layout-toggle"
              aria-label="Layout options"
            >
              <IconGrid />
            </button>
            <button
              type="button"
              className="adv-date-btn"
              aria-label="From date"
            >
              -
            </button>
            <button
              type="button"
              className="adv-date-btn"
              aria-label="To date"
            >
              <span role="img" aria-label="calendar">
                📅
              </span>
            </button>
          </div>

          <div className="adv-filters-right">
            <div className="adv-search">
              <input type="text" placeholder="Search" aria-label="Search advances" />
              <span className="adv-search-icon">
                <IconSearch />
              </span>
            </div>
          </div>
        </div>

        <div className="adv-table-wrapper">
          <table className="adv-table">
            <thead>
              <tr>
                {COLUMNS.map((col) => (
                  <th key={col.key}>{col.label}</th>
                ))}
                <th />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{SAMPLE_ADVANCE.id}</td>
                <td>{SAMPLE_ADVANCE.employee}</td>
                <td>{SAMPLE_ADVANCE.amount}</td>
                <td>{SAMPLE_ADVANCE.date}</td>
                <td>{SAMPLE_ADVANCE.deductionMonth}</td>
                <td>{SAMPLE_ADVANCE.installments}</td>
                <td>
                  <div className="adv-installment-chips">
                    {SAMPLE_ADVANCE.details.map((d) => (
                      <span key={d} className="adv-installment-chip">
                        {d}
                      </span>
                    ))}
                  </div>
                </td>
                <td>
                  <div className="adv-row-actions">
                    <button
                      type="button"
                      className="adv-row-icon-btn"
                      onClick={() => setShowEditModal(true)}
                      aria-label="Edit advance"
                    >
                      <IconEdit />
                    </button>
                    <button
                      type="button"
                      className="adv-row-icon-btn"
                      onClick={() => setShowDeleteModal(true)}
                      aria-label="Delete advance"
                    >
                      <IconTrash />
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="adv-footer-row">
          <div className="adv-footer-left">
            <select
              className="adv-page-size"
              defaultValue="100"
              aria-label="Rows per page"
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            <span>1-1 / 1</span>
          </div>
          <div className="adv-footer-right">
            <button
              type="button"
              className="adv-page-btn"
              aria-label="Previous page"
            >
              «
            </button>
            <button
              type="button"
              className="adv-page-btn adv-page-btn-active"
              aria-label="Current page"
            >
              1
            </button>
            <button
              type="button"
              className="adv-page-btn"
              aria-label="Next page"
            >
              »
            </button>
          </div>
        </div>
      </div>

      {showAddModal && (
        <div
          className="estimates-modal-backdrop"
          onClick={() => setShowAddModal(false)}
        >
          <div
            className="estimates-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="estimates-modal-header">
              <h2 className="estimates-modal-title">Add Advance</h2>
              <button
                type="button"
                className="estimates-modal-close"
                onClick={() => setShowAddModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className="estimates-modal-body">
              <div className="estimates-form-grid">
                <div className="estimates-form-label">Employee</div>
                <select className="estimates-form-select" defaultValue="">
                  <option value="">-</option>
                </select>

                <div className="estimates-form-label">Amount</div>
                <input className="estimates-form-input" placeholder="Amount" />

                <div className="estimates-form-label">Date</div>
                <input className="estimates-form-input" placeholder="Date" />

                <div className="estimates-form-label">Installments</div>
                <input className="estimates-form-input" defaultValue="1" />

                <div className="estimates-form-label">Deduction Month</div>
                <input
                  className="estimates-form-input"
                  placeholder="Deduction Month"
                />
              </div>
            </div>

            <div className="estimates-modal-footer">
              <button
                type="button"
                className="estimates-footer-btn"
                onClick={() => setShowAddModal(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="estimates-footer-btn estimates-footer-btn-primary"
                onClick={() => setShowAddModal(false)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {showEditModal && (
        <div
          className="estimates-modal-backdrop"
          onClick={() => setShowEditModal(false)}
        >
          <div
            className="estimates-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="estimates-modal-header">
              <h2 className="estimates-modal-title">Edit Advance</h2>
              <button
                type="button"
                className="estimates-modal-close"
                onClick={() => setShowEditModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className="estimates-modal-body">
              <div className="estimates-form-grid">
                <div className="estimates-form-label">Employee</div>
                <select
                  className="estimates-form-select"
                  defaultValue={SAMPLE_ADVANCE.employee}
                >
                  <option value={SAMPLE_ADVANCE.employee}>
                    {SAMPLE_ADVANCE.employee}
                  </option>
                </select>

                <div className="estimates-form-label">Amount</div>
                <input
                  className="estimates-form-input"
                  defaultValue={SAMPLE_ADVANCE.amount}
                />

                <div className="estimates-form-label">Date</div>
                <input
                  className="estimates-form-input"
                  defaultValue={SAMPLE_ADVANCE.date}
                />

                <div className="estimates-form-label">Installments</div>
                <input
                  className="estimates-form-input"
                  defaultValue={SAMPLE_ADVANCE.installments}
                />

                <div className="estimates-form-label">Deduction Month</div>
                <input
                  className="estimates-form-input"
                  defaultValue={SAMPLE_ADVANCE.deductionMonth}
                />
              </div>
            </div>

            <div className="estimates-modal-footer">
              <button
                type="button"
                className="estimates-footer-btn"
                onClick={() => setShowEditModal(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="estimates-footer-btn estimates-footer-btn-primary"
                onClick={() => setShowEditModal(false)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <div
          className="estimates-modal-backdrop"
          onClick={() => setShowDeleteModal(false)}
        >
          <div
            className="estimates-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="estimates-modal-header">
              <h2 className="estimates-modal-title">Delete Advance?</h2>
              <button
                type="button"
                className="estimates-modal-close"
                onClick={() => setShowDeleteModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>
            <div className="estimates-modal-body">
              <p>Are you sure? You won&apos;t be able to undo this action!</p>
            </div>
            <div className="estimates-modal-footer">
              <button
                type="button"
                className="estimates-footer-btn"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="estimates-footer-btn estimates-footer-btn-primary"
                onClick={() => setShowDeleteModal(false)}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

